<script>
export default {
  data() {
    return {
      defaultColor: '#cecece',
      colorChoices: [
        {
          label: 'Principale',
          value: 'primary',
        },
        {
          label: 'Secondaire',
          value: 'secondary',
        },
        {
          label: 'Personnalisée',
          value: 'custom',
        },
      ],
      colorChoicesExtended: [
        {
          label: 'Principale',
          value: 'primary',
        },
        {
          label: 'Secondaire',
          value: 'secondary',
        },
        {
          label: 'Nuances de gris',
          value: 'b&w',
        },
        {
          label: 'Personnalisée',
          value: 'custom',
        },
      ],
    };
  },
  methods: {
    /**
     * Keep only desired params
     * @param {object} config
     * @returns {object} Filtered config
     */
    filterConfig({
      theme, icons, elements, position, name, description, isDefault,
      map, zoom, fullscreen, locate, geosearch, carto, popin, boundary, preprod, legend
    }) {
      return {
        theme,
        icons,
        elements,
        position,
        name,
        description,
        isDefault,
        map,
        zoom,
        fullscreen,
        locate,
        geosearch,
        carto,
        popin,
        boundary,
        preprod,
        legend,
      };
    },
    /**
     * Get the corresponding hexadecimal color for the given **key**
     * @param {string} key The key to find the color from
     * @returns {string} An hexadecimal code
     */
    getColorFrom(key) {
      switch (key) {
        case 'primary':
          return this.config.theme.colors.primary;
        case 'secondary':
          return this.config.theme.colors.secondary;
        case 'custom':
          return '#cecece';
        default:
          return '#595959';
      }
    },
    /**
     * Get the corresponding key for the given hexadecimal **color**
     * @param {string} color The color to find the key from
     * @param {boolean} hasGreyColor Enable to return the key for grey color instead of *custom*
     * @returns {string} The key corresponding to hexadecimal code
     */
    getKeyFrom(color, hasGreyColor = false) {
      switch (color) {
        case this.config.theme.colors.primary:
          return 'primary';
        case this.config.theme.colors.secondary:
          return 'secondary';
        case '#595959':
          if (hasGreyColor) return 'b&w';
        // eslint-disable-next-line no-fallthrough
        default:
          return 'custom';
      }
    },
  },
};
</script>
